import React, { Component } from "react";
export default class MemoryDelayedRecall extends Component {
  render() {
    var {
      delayed_recall_check_1,
      delayed_recall_check_2,
      delayed_recall_check_3,
      delayed_recall_check_4,
      delayed_recall_check_5,
      delayed_recall_check_6,
      delayed_recall_check_7,
      delayed_recall_check_8,
      delayed_recall_check_9,
      delayed_recall_check_10,
      delayed_recall_value,
      delayed_recall_score,
      recall_score,
      percentageMeomeryCall,
    } = this.props.data;
    return (
      <div>
        <div className="row border border-dark bg-white">
          <div className="col-lg-12">
            <br />
            <div className="row" style={{ marginTop: 30 }}>
              <div className="col-lg-6">
                <span className="fs-19">Score (0 - 10) </span>
                <input
                  type="number"
                  name="delayed_recall_score"
                  value={delayed_recall_score}
                  onChange={this.handleChange}
                  className="ecas-input-field"
                  placeholder="Score"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
